import { useQuery, useQueryClient } from 'react-query'
import { useNavigate, useParams } from 'react-router-dom'
import { graphQLClient } from '../services/authService'
import customerQueries from '../services/graphql/customers/queries'
import { Customer } from '../types/customer'

export function useCustomer(id?: string) {
  const { customerId = id } = useParams<{ customerId: string }>()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  return useQuery<Customer, any>(
    ['customer', customerId],
    async () => {
      const result = await graphQLClient.request(customerQueries.getCustomer, {
        where: {
          id: customerId,
        },
      })

      return result.customer
    },
    {
      enabled: !!customerId,
      placeholderData: () => {
        const customers = queryClient.getQueryData<Customer[]>('customers')

        if (!customers) return undefined

        return customers.find((user) => user.id === customerId)
      },
      onError: () => {
        navigate('/customers')
      },
      select: ({ claimedPlaces, ...rest }) => ({
        ...rest,
        claimedPlaces:
          claimedPlaces && claimedPlaces.length > 0
            ? claimedPlaces.map(({ googlePlaceId, name, address }) => ({
                googlePlaceId,
                description: `${name} ${address}`,
              }))
            : [],
      }),
    }
  )
}
